import React from 'react';
import { showPricePerUnit } from '../../../Utils/CategoryPageUtils';
import { convertPrice, getCountry } from '../../../Utils/ForeignUtils';
import { InclTax } from '../../Product/ProductDetail/styled';
import { Discount, ProductPrice, StrikePrice, TotalAmount } from './styled';

function PriceSectionLive(props) {
  const { productData, userType } = props;

  const { symbol, price } = convertPrice(
    productData?.actual_web_price || productData?.price,
  );
  const { price: strikeprice } = convertPrice(productData?.strikeprice, true);
  const country = getCountry();
  //  const perUnit = showPricePerUnit(userType, productData?.pricePerUnit);
  return (
    <>
      {showPricePerUnit(userType, productData?.pricePerUnit) ? (
        <ProductPrice perUnit>
          <div className="price">
            <TotalAmount perUnit isUAE={country === 'uae'}>
              <sup>{symbol}</sup>
              {price}
            </TotalAmount>
            <div className="pricePerUnit">{productData?.pricePerUnit}</div>
          </div>
          <div className="mainPriceContainer">
            {productData?.strikeprice > productData?.price && (
              <StrikePrice className="span">
                MRP {symbol}
                <span>{strikeprice}</span>
              </StrikePrice>
            )}
            {productData?.strikeprice > productData?.price && (
              <Discount perUnit className="span">
                {productData?.discountPercent}% OFF
              </Discount>
            )}
            <InclTax perUnit>(incl. of all taxes)</InclTax>
          </div>
        </ProductPrice>
      ) : (
        <ProductPrice>
          <TotalAmount isUAE={country === 'uae'}>
            <sup>{symbol}</sup>
            {price}
          </TotalAmount>
          {productData?.strikeprice > productData?.price && (
            <StrikePrice className="span">
              MRP {symbol}
              <span>{strikeprice}</span>
            </StrikePrice>
          )}
          {productData?.strikeprice > productData?.price && (
            <Discount className="span">
              {productData?.discountPercent}% OFF
            </Discount>
          )}
        </ProductPrice>
      )}
    </>
  );
}

export default PriceSectionLive;
